/**
 * @generated SignedSource<<5dbffe5bde88bb61fb40f3be411566a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectCoverPhotoContainer_searchResult$data = {
  readonly project: {
    readonly tradeCoverPhoto: {
      readonly caption: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"ProjectPhoto_tradePhoto">;
    } | null;
  } | null;
  readonly " $fragmentType": "ProjectCoverPhotoContainer_searchResult";
};
export type ProjectCoverPhotoContainer_searchResult$key = {
  readonly " $data"?: ProjectCoverPhotoContainer_searchResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectCoverPhotoContainer_searchResult">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectCoverPhotoContainer_searchResult",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "designProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TradePhoto",
          "kind": "LinkedField",
          "name": "tradeCoverPhoto",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ProjectPhoto_tradePhoto"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "caption",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradeInteriorProjectQueryOutput",
  "abstractKey": null
};

(node as any).hash = "da2a1afe0649793de405502bc374dae9";

export default node;
